import React, { Component } from "react";
import { ExportBillingFileTable } from "./ExportBillingFileTable";

export class ExportBillingFile extends Component {
  render() {
    return <ExportBillingFileTable />;
  }
}
